// extracted by mini-css-extract-plugin
module.exports = {"card":"DoughnutTotal_card__bZ3U8","mainContent":"DoughnutTotal_mainContent__DDYe1","dataset":"DoughnutTotal_dataset__xfTx4","doughnut":"DoughnutTotal_doughnut__gG4tb"};